import { EventContentArg } from '@fullcalendar/core';
import { Box } from '@mui/material';
import { isEventShorterThanOneHour } from './helpers';
import { eventTileStyles, textEllipsis } from './styles';

export default function EventTile(eventInfo: EventContentArg) {
  const { event, timeText } = eventInfo;
  const title = event?.title ?? '';
  const time = timeText ?? '';
  const isShortEvent = isEventShorterThanOneHour(event?.start, event?.end);
  const tooltipText = time ? `${title}\n${time}` : title;

  return (
    <Box sx={eventTileStyles.container} title={tooltipText}>
      <Box component='span' sx={textEllipsis}>
        <Box component='span' sx={eventTileStyles.title}>
          {title}
        </Box>
        {isShortEvent && time && (
          <Box component='span' sx={eventTileStyles.time}>
            {' '}
            {time}
          </Box>
        )}
      </Box>

      {!isShortEvent && time && (
        <Box component='span' sx={eventTileStyles.longEventTime}>
          {time}
        </Box>
      )}
    </Box>
  );
}
